import * as React from 'react';
import { Container, TituloSecao } from './styles';

import Botao from '../../componentes/Botao';
import Grid from '../../componentes/Grid';
import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import userContext from '../../Context/UserContext';
import { FormatarUrlName } from '../../helpers/valores';

const Editora: React.FC = () => {
  const {id, name}: any = useParams();
  const currentlyUser = useContext(userContext);
  const {Codcliente, Codempresacli} = currentlyUser.user;
   const nomeFormatado = FormatarUrlName(decodeURIComponent(name));

  return (
    <Container>
      <TituloSecao>
        Editora {nomeFormatado} 
      </TituloSecao>
      <Grid Titulo={"Editora" + nomeFormatado} Editora={id} Codcliente={Codcliente} Codempresacli={Codempresacli}/>
    </Container>
  )
};

export default Editora;
